import ImageBodyCopy from './component'
export default ImageBodyCopy
